/**
 * MONTY — ADD TO CART
 * Le libelle et l'etat du bouton suivent la variante choisie. Le theme
 * envoie « variant:change » a chaque changement, avec la variante dedans :
 * on n'a qu'a ecouter. L'ajout au panier lui-meme est fait par le
 * formulaire <form is="product-form"> d'Impact, pas par ce script.
 */
(function () {
  'use strict';

  if (window.montyAddToCart) return;
  window.montyAddToCart = true;

  function metAJour(bouton, variante) {
    var libelle = bouton.querySelector('[data-monty-atc-label]');
    if (!libelle) libelle = bouton;

    if (!variante) {
      bouton.disabled = true;
      libelle.textContent = bouton.getAttribute('data-label-unavailable') || 'Unavailable';
      return;
    }
    if (variante.available) {
      bouton.disabled = false;
      libelle.textContent = bouton.getAttribute('data-label-add') || 'Add to cart';
    } else {
      bouton.disabled = true;
      libelle.textContent = bouton.getAttribute('data-label-sold-out') || 'Sold out';
    }
  }

  document.addEventListener('variant:change', function (e) {
    var detail = e.detail || {};
    var idForm = detail.formId;
    var boutons = document.querySelectorAll('[data-monty-atc]');
    for (var i = 0; i < boutons.length; i++) {
      var form = boutons[i].closest('form');
      /* Un seul formulaire par page en general ; le filtre couvre le cas
         d'une carte produit rapide ouverte par-dessus.
         Attention : « form.id » renvoie le champ nomme « id », pas
         l'identifiant du formulaire. D'ou getAttribute. */
      if (idForm && form && form.getAttribute('id') !== idForm) continue;
      metAJour(boutons[i], detail.variant);
    }
  });
})();
